import {
  WORKER_UPDATE, WORKERS_ERROR, WORKERS_LOADING, WORKER_REMOVE, WORKERS_STATE_UPDATE,
  WORKERS_UPDATE, WORKER_LIST_CLEAR
} from "../actions/workerActions";
import {I18nUtils} from "../../../i18n/I18nUtils";
import _ from 'lodash';

const INITIAL_STATE = {
  workers: [],
  workersPagination: null,
  workersLoading: false,
  workersError: null,
  workersStates: [
    {
      "id": 0,
      "name": I18nUtils.tr('TR_TODOS'),
    },
  ],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKERS_STATE_UPDATE:
      return {
        ...state,
        workersStates: [...INITIAL_STATE.workersStates, ...action.payload.data],
      };
    case WORKERS_UPDATE:
      return {
        ...state,
        workers: _.mapKeys(action.payload.data, "id"),
        workersPagination: action.payload.pagination,
        workersError: action.payload.message,
      };

    case WORKER_REMOVE:
      const workersToRemove = {...state.workers};
      delete workersToRemove[action.payload];
      return { ...state, workers: workersToRemove };

    case WORKER_UPDATE:
      const worker = action.payload.data;
      const workers = {...state.workers, [worker.id]: worker};
      return { ...state, workers: workers };
    case WORKERS_ERROR:
      return {
        ...state,
        workersError: action.payload,
      };
    case WORKERS_LOADING:
      return {
        ...state,
        workersLoading: action.payload,
      };
    case WORKER_LIST_CLEAR:
      return {
        ...state,
        workers: []
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/worker/reducers/WorkerReducer.js